import dayjs from 'dayjs'
import { HoursInterval } from '../../store/types'
import DateFormat from '../../store/types/enums/DateFormat'
import { checkIfAnyTimePeriodOverlaps } from '../../store/utils'

export const sortIntervals = (intervals: HoursInterval[]) => {
  return [...intervals].sort((a, b) => {
    if (a.from === '-' || b.from === '-') {
      return -1
    }

    return dayjs(a.from, DateFormat.HourMinute).diff(dayjs(b.from, DateFormat.HourMinute))
  })
}

export const areIntervalsValid = (intervals: HoursInterval[]) => {
  if (intervals.length === 1 && intervals[0].from === '-' && intervals[0].to === '-' && intervals[0].notShow) {
    return true
  }

  const hasInvalidInterval = intervals.some(interval => {
    if (interval.from === '-' || interval.to === '-') {
      return true
    }

    const from = dayjs(interval.from, DateFormat.HourMinute, true)
    const to = dayjs(interval.to, DateFormat.HourMinute, true)

    if (!from.isValid() || !to.isValid()) {
      return true
    }

    const midnight = dayjs('00:00', DateFormat.HourMinute)
    const isSameAsMidnight = to.isSame(midnight, 'minute')
    return to.isBefore(from) && !isSameAsMidnight
  })

  if (hasInvalidInterval) {
    return false
  }

  return !checkIfAnyTimePeriodOverlaps(intervals)
}
